import { addDays, format, isSameDay } from 'date-fns';

import { formatDate } from './format-date';

export function formatDateFuture(date: Date) {
  const today = new Date();
  if (isSameDay(date, today)) {
    // return "at <hh:mm>"
    return `at ${format(date, 'HH:mm')}`;
  }

  if (isSameDay(date, addDays(today, 1))) {
    return 'tomorrow';
  }

  return `on ${formatDate(date)}`;
}
